import { useEffect, useRef, useState } from "react";
import { useVzhlad } from "../../context/VzhladContext";
import VzhladPrepinac, { MOZNOSTI } from "./VzhladPrepinac";

/**
 * Ikona vzhľadu v hlavičke (prevádzka, marketing, /sprava) — pre každého,
 * prihláseného aj nie, aby bol režim na jeden klik. Ukazuje zvolenú
 * možnosť; po kliknutí otvorí malé okienko s VzhladPrepinac.
 */
function VzhladTlacidlo({ className = "" }) {
  const { volba } = useVzhlad();
  const [otvorene, setOtvorene] = useState(false);
  const obalRef = useRef(null);
  const aktualna = MOZNOSTI.find((m) => m.volba === volba) ?? MOZNOSTI[0];
  const { Ikona } = aktualna;

  useEffect(() => {
    if (!otvorene) return undefined;
    const klik = (e) => {
      if (obalRef.current && !obalRef.current.contains(e.target)) setOtvorene(false);
    };
    const klaves = (e) => {
      if (e.key === "Escape") setOtvorene(false);
    };
    document.addEventListener("mousedown", klik);
    document.addEventListener("keydown", klaves);
    return () => {
      document.removeEventListener("mousedown", klik);
      document.removeEventListener("keydown", klaves);
    };
  }, [otvorene]);

  return (
    <div className={`vzhlad-tlacidlo ${className}`.trim()} ref={obalRef}>
      <button
        type="button"
        className="vzhlad-tlacidlo__ikona"
        aria-label={`Vzhľad: ${aktualna.label}`}
        title="Vzhľad"
        aria-expanded={otvorene}
        aria-haspopup="true"
        onClick={() => setOtvorene((o) => !o)}
      >
        <Ikona size={18} aria-hidden="true" />
        {/* Viditeľný len tam, kde ho štýl hlavičky zapne (bočný panel na mobile). */}
        <span className="vzhlad-tlacidlo__text" aria-hidden="true">Vzhľad</span>
      </button>
      {otvorene && (
        <div className="vzhlad-tlacidlo__okno">
          <VzhladPrepinac />
        </div>
      )}
    </div>
  );
}

export default VzhladTlacidlo;
